<template>
  <div class="container-fluid">
    <div class="container text-center">

      <img
        style="height: auto; max-width:150px !important;"
        :src="logoUrl"
        class="img-fluid mx-auto d-block"
        alt="Logo"
      />

      <form @submit.prevent="verifyOtp" class="form-signin">
        <h5 class="py-1">
          Enter the OTP sent to your phone<span v-if="maskedPhone"> ending in ...{{ maskedPhone }}</span>
        </h5>

        <div class="form-group last mb-4">
          <input
            v-model="form.otp"
            placeholder="Enter OTP"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.otp }"
            required
          />
          <span v-if="errors.otp" class="invalid-feedback">
            <strong>{{ errors.otp }}</strong>
          </span>
        </div>

        <button type="submit" class="btn btn-block btn-dukakit">
          Verify OTP
        </button>

        <p class="py-2">
          Didn't get the code?
          <span v-if="resendTimer > 0" class="text-muted">Resend in {{ resendTimer }}s</span>
          <a v-else href="#" @click.prevent="resendOtp" class="text-primary">Resend OTP</a>
        </p>

      </form>

      <div class="pt-5">
        <p>&copy; {{ year }} All Rights Reserved. Dukakit</p>
      </div>

    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      logoUrl: '/images/logo.png',
      year: new Date().getFullYear(),
      form: {
        phone: '',
        otp: ''
      },
      maskedPhone: '',
      resendTimer: 40,
      timerInterval: null,
      errors: {}
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const phone = params.get('otp-no');

    if (phone) {
      this.form.phone = phone;
      this.maskedPhone = phone.slice(-4);
      console.log(phone)
    }
    else{
         console.log("No phone number")
    }

    this.startResendCountdown();
  },
  methods: {
    async verifyOtp() {
      try {
        this.errors = {};
        const response = await axios.post('/api/verify-otp', this.form);
        if (response.status === 200) {
          window.location.href = '/onboarding';
        }
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          alert('Invalid OTP or phone number.');
        }
      }
    },
    async resendOtp() {
      try {
        await axios.post('/api/resend-otp', { phone: this.form.phone });
        alert('OTP resent successfully.');
        this.resendTimer = 30;
        this.startResendCountdown();
      } catch (error) {
        alert('Failed to resend OTP.');
      }
    },
    startResendCountdown() {
      clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    }
  }
};
</script>


